import React from 'react';
import PropTypes from 'prop-types';

function MessageBarTwo({ message }) {
  return (
    <div>
      <p className="font-semibold">{message}</p>
    </div>
  );
}

MessageBarTwo.propTypes = {
  message: PropTypes.string.isRequired,
};

export default MessageBarTwo;
